import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';

export default function Newsletter({
    global,
    pathPrefix,
    customClass = "",
    content,
    content_2,
    formId,
    successPageUrl,
    buttonLink,
    buttonTitle,
    buttonLink2,
    buttonTitle2
}) {

    return (
        <section className={`${styles.root} ${customClass}`} >
            <Container>
                <Row>
                    <Col md={4} className="pe-md-5 mb-4 mb-md-0 pt-md-4">
                        {content ?
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                {content}
                            </SourceFlowText>
                            : null}
                        {buttonLink ?
                            <div className="mt-4">
                                <Link href={`${buttonLink}`}>
                                    <a className="primaryBtn no-arrow">
                                        {buttonTitle}
                                    </a>
                                </Link>
                                {buttonLink2 ?
                                    <Link href={`${buttonLink2}`}>
                                        <a className="primaryBtn primary-outline-border no-arrow m-0">
                                            {buttonTitle2}
                                        </a>
                                    </Link> : null}
                            </div> : null}
                    </Col>
                    <Col md={8} className="ps-md-5">
                        <div className="rightColumnWrapper p-4 rounded-4">
                            {content_2 ?
                                <div className="mb-5">
                                    <SourceFlowText global={global} path={`${pathPrefix}.content_2`} type="html">
                                        {content_2}
                                    </SourceFlowText>
                                </div>
                                : null}
                            {formId ?
                                <SourceFlowForm
                                    formId={formId}
                                    onSubmitDone={() => (window.location.href = successPageUrl)}
                                /> : ""}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}